/* eslint-disable import/first */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import css from './index.module.scss';

const QRSkelton = () => {
  return (
    <>
      <div className={css.skeltonRoot}>
        <Skeleton count={1} className={css.SkeletonLoad} height={275} />
        <Skeleton count={1} className={css.SkeletonLoad} height={43} />
        <Skeleton count={1} className={css.SkeletonLoad} height={120} />
        <Skeleton count={1} className={css.SkeletonLoad} height={40} />
      </div>
    </>
  );
};

export default QRSkelton;
